export default __webpack_public_path__ + "assets/webgl/picking-11.23b68ed6.glb";